var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{attrs:{"data-test":_vm.dataTest}},[_vm._t("default"),_vm._v(" "),_c('span',{staticStyle:{"color":"red"}},[_vm._t("red")],2),_vm._v(" "),_vm._l((_vm.errorList),function(x){return (_vm.errorList.length>0)?_c('b',[_vm._v("\n    "+_vm._s(x)+"\n  ")]):_vm._e()}),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.check()}}},[_vm._v("PrList验证Pr")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69c0e177","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/test/PrList.vue
// module id = 168
// module chunks = 0